"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.history = exports.default = void 0;
var _history = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/history"));
var _immutable = require("immutable");
var _configureStore = _interopRequireDefault(require("cornerstone_ui_core/lib/configureStore"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const initialState = (0, _immutable.fromJS)({});
const history = exports.history = _history.default;
var _default = exports.default = (0, _configureStore.default)(initialState, history);